import React from 'react';
import classnames from 'classnames';

import style from './index.scss';

const INDIVIDUAL_VIEW = '0';
const CORPORATE_VIEW = '1';

const BuSwitcher = (props) => {
  if (props) {
    const { activeBU, onBUSwitchChange } = props;

    return (
      <div className="btn-group pull-right">
        <button
          id="left-bu"
          className={classnames(
            activeBU == INDIVIDUAL_VIEW ? style.buTabActive : style.buTab,
            'btn'
          )}
          onClick={() => {
            onBUSwitchChange(INDIVIDUAL_VIEW);
          }}>
          Individual
        </button>
        <button
          id="right-bu"
          className={classnames(
            activeBU == CORPORATE_VIEW ? style.buTabActive : style.buTab,
            'btn'
          )}
          onClick={() => {
            onBUSwitchChange(CORPORATE_VIEW);
          }}>
          Corporate
        </button>
      </div>
    );
  }

  return null;
};

export default BuSwitcher;
